import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectOfferId } from 'shared/selectors/offerData';

const OFFER_ID_TEMPLATE = '{offerId}';

type TSource = 'offer_card_main_button' | 'offer_card_gallery_banner';

export const useOfferBookingUrl = (source: TSource) => {
  const offerId = useSelector(selectOfferId);

  const { config } = useApplicationContext();
  const urlTemplate = config.get<string>('newbuildingBroker.offerBookingUrlTemplate') ?? /* istanbul ignore next */ '';

  return useMemo(() => {
    const url = urlTemplate.replace(OFFER_ID_TEMPLATE, String(offerId));
    const separator = url.includes('?') ? '&' : '?';

    return `${url}${separator}cian_source=${source}`;
  }, [offerId, source, urlTemplate]);
};
